module.exports = __webpack_public_path__ + "img/nerd-face.5d1ca63c.png";